module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Article-d4748ae7565297377614add163d25ea3.svg";